module.exports = __webpack_public_path__ + "2ee1711b4461b7aa1257eadaaeb83f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/left-cylinder-part.png
// module id = 808
// module chunks = 0